export default {
	pages: {
		home: 'Bem-vindo à loja de equipamentos ao ar livre!',
		products: 'Produtos',
		interactive: 'Explorador de Equipamentos Interativo',
		environmental: 'Nosso compromisso',
		cart: 'Carrinho',
		login: 'Entrar',
	},
	interactive_gear_explorer: {
		title: 'Explorador de Equipamentos Interativo',
		steps: {
			0: 'Qual atividade você está planejando?',
			1: 'Qual é o seu orçamento?',
			2: 'Estes são os produtos recomendados para você!',
		},
		buttons: {
			hiking: 'Caminhada',
			climbing: 'Escalada',
			camping: 'Acampamento',
		},
	},
	header: {
		home: 'Início',
		admin: 'Admin',
		interactive: 'Explorador de Equipamentos Interativo',
		environmental: 'Compromisso Ambiental',
		products: 'Produtos',
		cart: 'Carrinho',
		login: 'Entrar',
		logout: 'Sair',
	},
	product_card: {
		add_to_cart: 'Adicionar ao Carrinho',
		goto_product: 'Ir para o Produto',
	},
	environment: {
		title: 'Nossos Compromissos Ambientais',
		sustainable_materials: {
			title: 'Materiais Sustentáveis',
			description:
				'Garantimos que todos os nossos materiais sejam provenientes de fornecedores que cumprem nossos rigorosos critérios de sustentabilidade.',
		},
		energy_efficiency: {
			title: 'Eficiência Energética',
			description:
				'Nossos processos de fabricação são otimizados para o mínimo consumo de energia, visando reduzir nossa pegada de carbono.',
		},
		waste_reduction: {
			title: 'Redução de Resíduos',
			description:
				'Reduzimos ativamente os resíduos por meio de iniciativas de reciclagem e projetando produtos que têm um ciclo de vida mais longo.',
		},
		green_packaging: {
			title: 'Embalagem Verde',
			description:
				'Transitando para soluções de embalagem sustentáveis, visamos minimizar o uso de materiais não decomponíveis.',
		},
		ecological_conservation: {
			title: 'Conservação Ecológica',
			description:
				'Apoiando vários programas de conservação ecológica, nos esforçamos para proteger o ambiente natural que é crucial para nossa sobrevivência.',
		},
		education_and_collaboration: {
			title: 'Educação e Colaboração',
			description:
				'Por meio de iniciativas educacionais e colaborações, estamos aumentando a conscientização ambiental e incentivando práticas mais verdes na indústria ao ar livre.',
		},
	},
	products: {
		title: 'Nossos Produtos',
		categories: {
			all: 'Todos',
			sleeping_bags: 'Sacos de Dormir',
			tents: 'Tendas',
			camping_chairs: 'Cadeiras de Acampamento',
			camping_tables: 'Mesas de Acampamento',
			portable_lights: 'Luzes Portáteis',
			stoves: 'Fogões',
			coolers: 'Refrigeradores',
			tools: 'Ferramentas',
			backpacks: 'Mochilas',
			other: 'Outros',
			kits: 'Kits',
			footwear: 'Calçados',
			undefined: 'Desconhecido',
		},
	},
	login: {
		title: 'Entrar',
		emailPlaceholder: 'Email',
		passwordPlaceholder: 'Senha',
		submit: 'Entrar',
		signup: 'Novo em nossa loja?',
		signupDescription: 'Inscreva-se agora para desfrutar de benefícios exclusivos!',
		signupBenefit: 'Receba as últimas notícias e atualizações sobre nossos produtos',
		signupBenefit2: 'Receba ofertas e descontos especiais',
	},
	footer: {
		title: 'Loja de Equipamentos ao Ar Livre',
		menu: {
			title: 'Menu',
			home: 'Início',
			products: 'Produtos',
			interactive: 'Explorador de Equipamentos Interativo',
			environmental: 'Compromisso Ambiental',
			cart: 'Carrinho',
			login: 'Entrar',
		},
		information: {
			title: 'Informação',
			about: 'Sobre Nós',
			contact: 'Contate-Nos',
			privacy: 'Política de Privacidade',
			terms: 'Termos & Condições',
			careers: 'Carreiras',
		},
	},
	home: {
		title: 'Prepare-se para o Exterior',
		products: 'Explore Nossos Produtos',
		environmental: 'Nossos Compromissos Ambientais',
		interactive: 'Experimente Nosso Explorador de Equipamentos Interativo',
	},
	product: {
		title: 'Detalhes do Produto',
		carbon_footprint: 'Pegada de Carbono',
		recyclable_materials: 'Materiais Recicláveis',
		end_of_life_options: 'Fim de Vida',
		add_to_cart: 'Adicionar ao Carrinho',
	},
};
